<div class="PGRating" role="radiogroup" [attr.aria-label]="ariaLabel || null" [attr.aria-required]="required || null">
    @for (rating of [1,2,3,4,5]; track rating) {
        <button type="button" class="btn btn-link" role="radio"
            [attr.aria-checked]="value == rating"
            [attr.aria-label]="'pg-rating.a11y.stars' | locTranslate:'count':rating"
            [disabled]="readonly"
            (click)="setValue(rating)">
            <div>
                <i class="{{icon != null ? icon : 'fa-star'}} fa-solid text-primary {{rating > value ? 'opacity-00' : 'opacity-100'}}" aria-hidden="true"></i>
                <i class="{{icon != null ? icon : 'fa-star'}} fa-regular text-muted" aria-hidden="true"></i>
            </div>
        </button>
    }
</div>
